import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  AuthLoginPayload,
  AuthOtpPayload,
  AuthResponse,
  AuthValidateBusinessDataPayload,
  AuthValidateOtpPayload,
  ChangePasswordPayload,
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  InviteSignupPayload,
  SignUpPayload,
} from "type/auth";

export const auth = createApi({
  reducerPath: "auth",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    signup: builder.mutation<any, SignUpPayload>({
      query: (body) => ({
        url: `register`,
        method: "POST",
        body,
      }),
    }),
    inviteSignup: builder.mutation<any, InviteSignupPayload>({
      query: (body) => ({
        url: `user/invited/register`,
        method: "POST",
        body,
      }),
    }),
    login: builder.mutation<AuthResponse, AuthLoginPayload>({
      query: (body) => ({
        url: `user/authenticate`,
        method: "POST",
        body,
      }),
    }),
    changePassword: builder.mutation<any, ChangePasswordPayload>({
      query: (body) => ({
        url: `user/changePassword`,
        method: "POST",
        body,
      }),
    }),
    sendAuthOtp: builder.mutation<any, AuthOtpPayload>({
      query: (body) => ({
        url: `onboarding/sendotp`,
        method: "POST",
        body,
      }),
    }),
    validateAuthOtp: builder.mutation<any, AuthValidateOtpPayload>({
      query: (body) => ({
        url: `onboarding/validateotp`,
        method: "POST",
        body,
      }),
    }),
    validateBusinessData: builder.mutation<
      any,
      AuthValidateBusinessDataPayload
    >({
      query: (body) => ({
        url: `onboarding/validateData`,
        method: "POST",
        body,
      }),
    }),
    forgotPassword: builder.mutation<
      ForgotPasswordResponse,
      ForgotPasswordPayload
    >({
      query: (body) => ({
        url: `user/passwordToken`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useSignupMutation,
  useChangePasswordMutation,
  useLoginMutation,
  useSendAuthOtpMutation,
  useValidateAuthOtpMutation,
  useValidateBusinessDataMutation,
  useForgotPasswordMutation,
  useInviteSignupMutation,
} = auth;
